import { render, staticRenderFns } from "./documentCompare copy.vue?vue&type=template&id=0231e4b0&scoped=true"
import script from "./documentCompare copy.vue?vue&type=script&lang=js"
export * from "./documentCompare copy.vue?vue&type=script&lang=js"
import style0 from "./documentCompare copy.vue?vue&type=style&index=0&id=0231e4b0&prod&scoped=true&lang=less"
import style1 from "./documentCompare copy.vue?vue&type=style&index=1&id=0231e4b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0231e4b0",
  null
  
)

export default component.exports